import { PayloadAction, createSelector, createSlice } from '@reduxjs/toolkit'

import * as u from '../utils'

const PREFIX = 'session'

const initialState: u.DBValues = u.emptyObj

const sessionSlice = createSlice({
  initialState,
  name: PREFIX,
  reducers: {
    setSessionVal(
      session,
      {
        payload: { key, value },
      }: PayloadAction<{ key: string; value: u.DBVal }>,
    ) {
      // Clash between immer and Readonly<>
      // @ts-expect-error
      session[key] = value
    },
  },
})

export const {
  actions: { setSessionVal },
  reducer: session,
} = sessionSlice

//#region selectors
type GlobalState = u.DeepReadonly<{
  [PREFIX]: u.DBValues
}>

export const selectSessionValues = ({ session }: GlobalState): u.DBValues => {
  if (Object.keys(session).length > 0) {
    return session
  }
  return u.EMPTY_OBJ
}

export type SelectSessionValParams = u.DeepReadonly<{
  key: string
}>

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/explicit-module-boundary-types
export const makeSelectSessionVal = () =>
  createSelector(
    selectSessionValues,
    (_: GlobalState, args: SelectSessionValParams) => args,
    (session, { key }): u.DBVal => session[key],
  )

export const selectSessionVal =
  <Cast = u.DBVal>(key: string) =>
  (state: GlobalState): Cast | undefined =>
    state[PREFIX][key] as Cast | undefined

//#endregion selectors
//#region sagas
//#endregion sagas
